import React, { useContext } from "react";

import { Avatar } from "@material-ui/core";

import { Context as AuthContext } from "../../../context/AuthContext";
import useStyles from "./styles";

import DefaultImg from "../../../assets/user.png";

const UserAvatar = ({ size = 32, margin = 0, toolbar }) => {
  const { avatarRoot, avatarClass } = useStyles({ size, margin, toolbar });
  const {
    state: { user },
  } = useContext(AuthContext);

  return (
    <div className={avatarRoot}>
      {user && user.avatar ? (
        <Avatar alt="user avatar" src={user.avatar} className={avatarClass} />
      ) : (
        <Avatar alt="user avatar" src={DefaultImg} className={avatarClass} />
      )}
    </div>
  );
};

export default UserAvatar;
